import BaseCommand from "@/models/api/commands/BaseCommand";

export interface UpdateTradeTermParams {
  ApplyTo: number; //0;
  CalculatedFrom: number; // 0;
  Currency: string; // "PLN";
  IsHidden: boolean; // false;
  IsPercentage: boolean; // false;
  Name: string; // "test";
  OrderItemId: string; // "75e492a0-40bb-4fd0-a421-2ce13b467bd0";
  PriceModifierToRootItem: boolean; // false;
  Quantity: number; // 1;
  SelectedTradeTermType: number; // 1;
  SeparateItem: boolean; // false;
  ServiceTypeId: number; // 370;
  Value: number; // "1.00";
}

export class UpdateTradeTermCommand extends BaseCommand {
  CommandName = "UpdateTradeTerm";
  Command: UpdateTradeTermParams;
  constructor(
    sessionId: string,
    operationId: string,
    params: UpdateTradeTermParams,
    afterExecuteCallback?: (result: unknown) => void
  ) {
    super(sessionId, operationId, afterExecuteCallback);
    this.Command = params;
  }
}
